<template>
	<div class="container-wrap">
		<div class="container">
			<div class="aside">
				<asideDocument :current="curNameId" @toDetail="toDetail" :menuList="menuList"></asideDocument>
				<!-- <asideNews :menuList="menuList"></asideNews> -->
				<!-- <ul class="menu">
					<li v-for="(item,index) in menuList">
						<div class="parent-item" >
							<i class="el-icon-caret-bottom" v-if="item.list&&item.list.length>0"></i>
							<i class="el-icon" v-else></i>
							<a class="anchor-link-title">{{item.categoryName}}</a>
						</div>
					</li>
				</ul> -->
			</div>
			<div class="content">
				<ul class="list" v-if="dataList.length>0">
					<li v-for="item in dataList" :key="item.id">
						<a href="javascript:;" @click="toSingleDocument(item)">{{item.title}}</a>
					</li>
				</ul>
				<!-- <div class="list-wrap" v-for="item in dataList" :key="item.id">
					<h1>{{item.title}}</h1>
					<ul class="list">
						<li v-for="subItem in item.list" :key="subItem.id">
							<a href="javascript:;">{{subItem.title}}</a>
						</li>
					</ul>
				</div> -->
			</div>
			<div class="clearfix"></div>
		</div>
	</div>
</template>
<script>
	import qs from 'qs'
	import asideDocument from '@/components/product/asideDocument'
	import asideNews from '@/components/product/asideNews'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'Home',
		components: {
			asideDocument,
			asideNews
		},
		data() {
			return {
				menuList: [],
				categoryIdOne: '',
				categoryIdTwo: '',
				dataList: [],
				curNameId: 0,
				id: ''
			}
		},
		created(){
			let id = this.$route.params.id
			this.id = id
			this.getCateList()
		},
		methods: {
			toSingleDocument(item){
				this.$router.push({
					path : '/singleDocument/'+item.columnId+'/'+item.id
					
				})
			},
			toDetail(e){
				this.curNameId = e.id
				//this.$set(e, 'curNameId', this.curNameId)
				if(e.parentId){
					this.categoryIdOne = e.parentId
					this.categoryIdTwo = e.id
				} else {
					this.categoryIdOne = e.id
					this.categoryIdTwo = ''
				}
				document.title = e.title
				//获取当前列表数据
				this.getDataList()
			},
			//获取当前列表数据
			async getDataList(){
				let param = {
					categoryIdOne: this.categoryIdOne,
					categoryIdTwo: this.categoryIdTwo
				}
				ajaxParam(param)
				const res = await post('v1/document/list', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取文章类型
			async getCateList(){
				let param = {
					id: this.id,
					typeCode: 'document'
				}
				ajaxParam(param)
				const res = await post('v1/category/tree', qs.stringify(param))
				if(res.data.code==200){
					let list = res.data.list
					for(var i=0; i<list.length; i++){
						list[i].isShowChild = true
					}
					this.menuList = res.data.list
					if(this.menuList.length>0) {
						this.categoryIdOne = this.menuList[0].id
						this.curNameId = this.menuList[0].id
						this.getDataList()
					}
				} else {
					this.$message.error(res.data.msg)
				}
			},
		}
	}
</script>
<style scoped lang="less">
	@import '../singleDocument/singleDocument.less';
	.menu{
		li{
			min-height: 32px !important;
			line-height: 32px;
			padding: 0 0 0 14px;
			a{
				color: rgba(0, 0, 0, .5)
			}
		}
	}
	.list-wrap{
		margin-bottom: 15px;
		h1{
			font-weight: 400;
			font-size: 18px;
			letter-spacing: 1.29px;
			line-height: 50px;
		}
	}
	
	.list{
		padding: 14px 23px;
		border: 1px solid #dadada;
		height: auto;
		display: flex;
		flex-wrap: wrap;
		li{
			flex: 33%;
			max-width: 31%;
			padding: 0 1%;
			line-height: 32px;
			a{
				color: #909399;
				-webkit-transition: all .3s;
				transition: all .3s;
			}
			a:hover{
				color: #DE0515;
			}
		}
	}
</style>
